export function ValidDate(date) {
  var d = new Date(date);
  if (d == "Invalid Date") return false;

  if (isNaN(d.getTime())) return false;

  return true;
}
